import React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import { getTiposEstablecimiento } from '../../services/Busquedas/TiposEstablecimiento';

const TipoEstablecimientoAutocomplete = React.forwardRef((props, ref) => {
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const [tipoEstablecimientoLabel, setTipoEstablecimientoLabel] =
    React.useState('Seleccioná el tipo');

  React.useEffect(() => {
    const getAllTiposEstablecimiento = async () => {
      const tiposEstablecimiento = await getTiposEstablecimiento();
      setOptions(tiposEstablecimiento);
    };

    try {
      if (options && options.length === 0) {
        getAllTiposEstablecimiento();
      }
    } catch (err) {
      console.error(err);
    }
  }, [options]);

  const handleChange = (event, newValue) => {
    props.onSelectTipoEstablecimiento(newValue);
    setTipoEstablecimientoLabel('Tipo establecimiento');
  };

  return (
    <Autocomplete
      id='tipo-establecimiento-autocomplete'
      open={open}
      onOpen={() => {
        setOpen(true);
      }}
      onClose={() => {
        setOpen(false);
      }}
      isOptionEqualToValue={(option, value) =>
        option.idTipoEstablecimiento === value.idTipoEstablecimiento
      }
      getOptionLabel={(a) => `${a.descripcion}`}
      onChange={handleChange}
      options={options}
      loading={options && options.length === 0}
      renderInput={(params) => (
        <TextField
          id='textTipoEstablecimiento'
          {...params}
          label={tipoEstablecimientoLabel}
          variant='standard'
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {options && options.length === 0 ? (
                  <CircularProgress color='inherit' size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
    />
  );
});

export default TipoEstablecimientoAutocomplete;
